

















































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SingleImageUpload from '@/component/single-image-upload.vue';
import moment, { Moment } from 'moment';
import { dateTime } from '@/util/adapter';
import { AxiosResponse } from 'axios';
const uuidv4 = require('uuid/v4');
const clean = require('bmh/clean-empty-obj');
const { VUE_APP_FCREST: FCREST, VUE_APP_FCAPI: FCAPI } = process.env;

enum ActivityStatus {
  waiting = 1,
  underway = 2,
  finished = 3,
}

interface Activity {
  name: string;
  duration: [Moment | undefined, Moment | undefined];
  status: ActivityStatus;
  address: string;
}

interface DataItem {
  id: number;
  level_two_num: number;
  level_two_additional_num: number;
  view_num: number;
  subscribe_num: number;
  apply_num: number;
  qrcode: string;
  latest_upload_time: Moment | undefined;
}

interface Summary extends DataItem {
  level_one_num: number;
}

interface Detail extends DataItem {
  name: string;
  mobile: string;
}

interface ModalDataItem {
  id: number;
  wechat_nickname: string;
  mobile: string;
  time: Moment | undefined;
  inviter_name: string;
  inviter_mobile: string;
}

interface Preview {
  visible: boolean;
  url: string;
}

interface Modal {
  is_show: boolean;
  title: string;
  time_row_text: string;
  api: string;
  level_one_id?: number;
  table: Pagination<ModalDataItem>;
}

interface FcapiModal {
  is_show: boolean;
  title: string;
  time_row_text: string;
  api: string;
  level_one_id?: number;
  table: FcapiRemotePagination<ModalDataItem>;
}

const API = {
  activity: `${FCREST}/promotion/shang/statement/activity`,
  view_num: `${FCREST}/promotion/shang/statement/visitor`,
  view_num_new: `${FCAPI}/shang/promotion/activity/stats/visitor`,
  apply_num: `${FCREST}/promotion/shang/statement/apply`,
  apply_num_new: `${FCAPI}/shang/promotion/activity/stats/apply`,
  subscribe_num: `${FCREST}/promotion/shang/statement/subscribe`,
};

const ACTIVITY_STATUS_MAP = {
  [ActivityStatus.waiting]: '未开始',
  [ActivityStatus.underway]: '进行中',
  [ActivityStatus.finished]: '已结束',
};

function getPreview(url: string = '', visible: boolean = false): Preview {
  return {
    url,
    visible,
  };
}

function getModal(
  is_show: boolean = false,
  title: string = '',
  time_row_text: string = '',
  api: string = '',
  level_one_id: number = 0,
  table: Pagination<ModalDataItem> = getModalData(),
): Modal {
  return {
    is_show,
    title,
    time_row_text,
    api,
    level_one_id,
    table,
  };
}
function getFcapiModal(
  is_show: boolean = false,
  title: string = '',
  time_row_text: string = '',
  api: string = '',
  level_one_id: number = 0,
  table: FcapiRemotePagination<ModalDataItem> = getFcapiModalData(),
): FcapiModal {
  return {
    is_show,
    title,
    time_row_text,
    api,
    level_one_id,
    table,
  };
}

function getModalData(
  remote?: RestRemotePagination<any>,
): Pagination<ModalDataItem> {
  remote = (remote || {}) as RestRemotePagination<any>;
  const current = remote.current;
  return {
    current: Number(current) || current || 1,
    data: (remote.data || []).map((item: any) => getModalDataItem(item)),
    last: remote.last || 1,
    size: remote.size || 1,
    total: remote.total || 0,
  };
}

function getFcapiModalData(
  remote?: FcapiRemotePagination<any>,
): FcapiRemotePagination<ModalDataItem> {
  remote = (remote || {}) as FcapiRemotePagination<any>;
  const current = remote.current;
  return {
    current: Number(current) || current || 1,
    detail: (remote.detail || []).map((item: any) => getModalDataItem(item)),
    last: remote.last || 1,
    limit: remote.limit || 1,
    total: remote.total || 0,
  };
}

function getModalDataItem(remote?: any): ModalDataItem {
  remote = remote || {};
  return {
    id: remote.id,
    wechat_nickname: remote.nickname || '',
    mobile: remote.mobile || '-',
    time: remote.create_time ? moment(remote.create_time * 1000) : undefined,
    inviter_name: remote.inviter_name || '',
    inviter_mobile: remote.inviter_mobile || '-',
  };
}

function getActivity(remote?: any): Activity {
  const activity = (remote || {}).activity_info || {};
  return {
    name: activity.name || '',
    duration: [
      activity.start_time ? moment(activity.start_time * 1000) : undefined,
      activity.end_time ? moment(activity.end_time * 1000) : undefined,
    ],
    status: activity.status || ActivityStatus.waiting,
    address: activity.address,
  };
}

function getSummary(remote?: any): Summary {
  remote = remote || {};
  const activity = remote.activity_info || {};
  return {
    id: activity.id || 0,
    level_one_num: (remote.clerk_detail || []).length,
    level_two_num: remote.clerk_count || 0,
    level_two_additional_num: remote.activity_clerk_count || 0,
    view_num: activity.page_view || 0,
    subscribe_num: activity.real_subscribe_number || 0,
    apply_num: activity.real_apply_number || 0,
    qrcode: '',
    latest_upload_time: activity.wx_qr_code_time
      ? moment(activity.wx_qr_code_time * 1000)
      : undefined,
  };
}

function getDetail(remote?: any): Detail {
  remote = remote || {};
  return {
    id: remote.clerk_id,
    name: remote.clerk_name || '',
    mobile: remote.clerk_mobile || '-',
    level_two_num: remote.clerk_count || 0,
    level_two_additional_num: remote.activity_clerk_count || 0,
    view_num: remote.page_view || 0,
    subscribe_num: remote.subscribe_number || 0,
    apply_num: remote.apply_number || 0,
    qrcode: remote.wx_qr_code || '',
    latest_upload_time: remote.qr_code_time
      ? moment(remote.qr_code_time * 1000)
      : undefined,
  };
}

@Component({
  components: {
    SingleImageUpload,
  },
})
export default class ActivityDetail extends Vue {
  is_loading: boolean = false;
  qrcode_preview: Preview = getPreview();
  modal: Modal = getModal();
  activity: Activity = getActivity();
  summary: Summary = getSummary();
  detail_list: Detail[] = [];
  is_fcapi: boolean = false;
  fcapi_modal: FcapiModal = getFcapiModal();
  modal_loading: boolean = false;

  get activityId(): number {
    return +this.$route.query.activity_id;
  }

  get activityStatusMap() {
    return ACTIVITY_STATUS_MAP;
  }

  exportUrl(level_one_id?: number) {
    let url: any = '';
    if (this.is_fcapi) {
      url = `${this.fcapi_modal.api}/?activity_id=${this.activityId}&clerk_id=${level_one_id}&is_export=1`;
      return url;
    } else {
      url = `${this.modal.api}/${this.activityId}`;
      if (!level_one_id) {
        return url;
      }
      return `${url}?clerk_id=${level_one_id}`;
    }
  }

  dateTime(time: Moment | undefined) {
    return time ? dateTime(time) : '';
  }

  handleQrCodePreview(item: Summary | Detail | boolean) {
    if (typeof item === 'boolean') {
      this.qrcode_preview = getPreview();
      return;
    }
    this.qrcode_preview = getPreview(item.qrcode, true);
  }

  handChangeModalPaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.queryModalTable(next_page);
  }

  paginationOption(data: Pagination<any>) {
    return {
      total: data.total,
      showTotal: (total: number) => `共${total}条，每页${data.size}条`,
      pageSize: data.size,
      current: data.current,
    };
  }

  // handChangePagingModal(pagination: any) {
  //   const next_page = pagination.current;
  //   this.getCouponList(next_page);
  // }

  paginationOptionFcapi(data: FcapiRemotePagination<any>) {
    return {
      total: data.total || 0,
      showTotal: () => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }

  showViewTableModal(item: Summary | Detail, from_activity: boolean) {
    this.is_fcapi = !from_activity;
    const { name, address, status, duration } = this.activity;
    const api = this.is_fcapi ? API.view_num_new : API.view_num;
    if (this.is_fcapi) {
      this.fcapi_modal = getFcapiModal(
        true,
        `${this.activityId}/${address}/${name}/${dateTime(
          duration[0],
        )}--${dateTime(duration[1])}/浏览总数${item.view_num}`,
        '初次浏览时间',
        api,
        from_activity ? undefined : item.id,
      );
    } else {
      this.modal = getModal(
        true,
        `${this.activityId}/${address}/${name}/${dateTime(
          duration[0],
        )}--${dateTime(duration[1])}/浏览总数${item.view_num}`,
        '初次浏览时间',
        api,
        from_activity ? undefined : item.id,
      );
    }
    this.queryModalTable();
  }

  showSubscribeTableModal(item: Summary | Detail, from_activity: boolean) {
    const { name, address, status, duration } = this.activity;
    const api = API.subscribe_num;
    this.modal = getModal(
      true,
      `${this.activityId}/${address}/${name}/${dateTime(
        duration[0],
      )}--${dateTime(duration[1])}/预约总数${item.subscribe_num}`,
      '预约时间',
      api,
      from_activity ? undefined : item.id,
    );
    this.queryModalTable();
  }

  showApplyTableModal(item: Summary | Detail, from_activity: boolean) {
    this.is_fcapi = !from_activity;
    const { name, address, status, duration } = this.activity;
    const api = this.is_fcapi ? API.apply_num_new : API.apply_num;
    if (this.is_fcapi) {
      this.fcapi_modal = getFcapiModal(
        true,
        `${this.activityId}/${address}/${name}/${dateTime(
          duration[0],
        )}--${dateTime(duration[1])}/报名总数${item.apply_num}`,
        '报名时间',
        api,
        from_activity ? undefined : item.id,
      );
    } else {
      this.modal = getModal(
        true,
        `${this.activityId}/${address}/${name}/${dateTime(
          duration[0],
        )}--${dateTime(duration[1])}/报名总数${item.apply_num}`,
        '报名时间',
        api,
        from_activity ? undefined : item.id,
      );
    }
    this.queryModalTable();
  }

  async queryModalTable(page: number = 1) {
    const send_data: any = {
      activity_id: this.activityId,
      clerk_id: this.is_fcapi
        ? this.fcapi_modal.level_one_id
        : this.modal.level_one_id || '',
    };
    if (this.is_fcapi) {
      send_data.current = page;
      send_data.limit = 10;
    } else {
      send_data.page = page;
    }
    clean(send_data);
    this.modal_loading = true;
    const _res = await this.$axios.get(
      this.is_fcapi ? this.fcapi_modal.api : this.modal.api,
      { params: send_data },
    );
    this.modal_loading = false;
    const _data = _res.data || {};
    if (_data.status !== 200) {
      this.$message.error(_data.message);
      return;
    }
    const data = _data.data;
    if (this.is_fcapi) {
      this.fcapi_modal.table = getFcapiModalData(data);
    } else {
      this.modal.table = getModalData(data);
    }
  }

  onModalExport() {
    const url = this.exportUrl(
      this.is_fcapi ? this.fcapi_modal.level_one_id : this.modal.level_one_id,
    );
    window.location.href = url;
  }

  onModalCancel() {
    this.modal = getModal();
    this.fcapi_modal = getFcapiModal();
  }

  async created() {
    this.is_loading = true;
    const _res = await this.$axios.get(
      `${API.activity}?activity_id=${this.activityId}`,
    );
    this.is_loading = false;
    const _data = _res.data || {};
    if (_data.status !== 200) {
      this.$message.error(_data.message);
      return;
    }
    const data = _data.data;
    const now_timestamp = +new Date();
    data.activity_info.status =
      data.activity_info.start_time * 1000 > now_timestamp
        ? 1
        : data.activity_info.end_time * 1000 > now_timestamp
        ? 2
        : 3;
    this.activity = getActivity(data);
    this.summary = getSummary(data);
    this.detail_list = (data.clerk_detail || []).map((item: any) =>
      getDetail(item),
    );
  }
}
